import React, { useEffect, useState } from "react";
import { Menu, Phone, X } from "lucide-react";
import logo from "./assets/img/logo-light.svg";
import { CONTACT, NAV } from "../data/content";
import { WhatsAppIcon } from "./ui";

const Header = ({ activeSection }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-ink-900"
      >
        Skip to content
      </a>

      <header
        className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
          scrolled || open
            ? "border-b border-white/10 bg-ink-950/80 backdrop-blur-xl"
            : "border-b border-transparent"
        }`}
      >
        <nav className="container flex h-16 items-center justify-between lg:h-20" aria-label="Primary">
          <a href="#top" className="flex shrink-0 items-center" onClick={() => setOpen(false)}>
            <img src={logo} alt="Fronix Studio" width="136" height="36" className="h-8 w-auto lg:h-9" />
          </a>

          <ul className="hidden items-center gap-1 rounded-full border border-white/10 bg-white/[0.03] p-1 lg:flex">
            {NAV.map((item) => {
              const active = activeSection === item.id;
              return (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    aria-current={active ? "true" : undefined}
                    className={`block rounded-full px-4 py-2 text-sm font-medium transition ${
                      active ? "bg-white/10 text-white" : "text-ink-300 hover:text-white"
                    }`}
                  >
                    {item.label}
                  </a>
                </li>
              );
            })}
          </ul>

          <div className="hidden items-center gap-2 lg:flex">
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="btn border border-white/10 text-ink-200 hover:border-[#25D366]/50 hover:text-[#25D366]"
            >
              <WhatsAppIcon /> WhatsApp
            </a>
            <a href={CONTACT.phoneHref} className="btn-primary">
              <Phone className="h-4 w-4" /> Call now
            </a>
          </div>

          <button
            type="button"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white lg:hidden"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            aria-controls="mobile-menu"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </nav>

        <div
          id="mobile-menu"
          className={`overflow-hidden transition-[max-height] duration-300 lg:hidden ${open ? "max-h-[32rem]" : "max-h-0"}`}
        >
          <div className="container pb-6">
            <ul className="flex flex-col gap-1 border-t border-white/10 pt-4">
              {NAV.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={() => setOpen(false)}
                    className={`block rounded-xl px-4 py-3 text-base font-medium ${
                      activeSection === item.id ? "bg-white/10 text-white" : "text-ink-200 hover:bg-white/5"
                    }`}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-4 grid grid-cols-2 gap-3">
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="btn bg-[#25D366] text-ink-950"
              >
                <WhatsAppIcon /> WhatsApp
              </a>
              <a href={CONTACT.phoneHref} className="btn-primary">
                <Phone className="h-4 w-4" /> Call now
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
